module.exports = __webpack_public_path__ + "static/media/login.91b6d609.svg";